<template>
  <v-container fluid class="edit-page">
    <!-- Edit Application Confirm Dialog -->
    <v-dialog v-model="alertEditApplicationDialog" max-width="460" content-class="edit-confirm-dialog">
      <div class="edit-confirm-card">
        <h3 class="edit-confirm-card__title">Edit Application</h3>
        <p class="edit-confirm-card__message">Are you sure to edit this application?</p>
        <div class="edit-confirm-card__actions">
          <button
            class="edit-confirm-card__btn edit-confirm-card__btn--cancel"
            @click="alertEditApplicationDialog = false"
          >
            Cancel
          </button>
          <button
            class="edit-confirm-card__btn edit-confirm-card__btn--confirm"
            @click="editApplication()"
          >
            Update
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Header -->
    <div class="edit-header">
      <div class="edit-header__top">

        <div v-if="!loadingDialog" class="edit-header__info">
          <h1 class="edit-header__title">{{ model.edit.name }}</h1>
        </div>

        <div class="edit-header__actions">
          <span v-if="this.isHrdcSuperAdminRoles">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="hero-action-btn hero-action-btn--dark"
                  @click.stop="alertEditApplicationDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <!-- Heroicon: floppy-disk / save -->
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 3.75h10.586a1.5 1.5 0 0 1 1.06.44l2.914 2.914a1.5 1.5 0 0 1 .44 1.06V19.5a1.5 1.5 0 0 1-1.5 1.5h-13.5a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 21v-4.5a1.5 1.5 0 0 0-1.5-1.5h-4.5a1.5 1.5 0 0 0-1.5 1.5V21" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 3.75v3h6v-3" />
                  </svg>
                </button>
              </template>
              <span>Save Changes</span>
            </v-tooltip>
          </span>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div v-if="!loadingDialog" class="cards-grid">
      <!-- LEFT COLUMN -->
      <div class="cards-column">
        <!-- Company Details -->
        <div class="section-card">
          <div class="section-header">
            <v-icon color="white" small>mdi-office-building-outline</v-icon>
            <span class="section-header__title">Company Details</span>
          </div>
          <div class="section-body">
            <div class="form-row">
              <label class="form-label">Company Name (Filled By Applicant)</label>
              <div class="form-field">
                <v-text-field
                  filled
                  dense
                  v-model="companyDetails.oriCompanyName"
                  :error-messages="errorField.oriCompanyName"
                  clearable
                ></v-text-field>
              </div>
            </div>

            <div class="form-row" v-show="paymentChannelDisabled">
              <label class="form-label">Company Name (Vision)</label>
              <div class="form-field">
                <v-text-field
                  filled
                  dense
                  v-model="companyDetails.oldCompanyName"
                  :error-messages="errorField.oldCompanyName"
                  clearable
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Company SSM No.</label>
              <div class="form-field">
                <v-text-field
                  filled
                  dense
                  v-model="companyDetails.companySsmNo"
                  :error-messages="errorField.companySsmNo"
                  clearable
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Company TIN No.</label>
              <div class="form-field">
                <v-text-field
                  filled
                  dense
                  v-model="companyDetails.companyTinNo"
                  :error-messages="errorField.companyTinNo"
                  clearable
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Company Address</label>
              <div class="form-field">
                <v-text-field
                  filled
                  dense
                  v-model="companyDetails.companyAddress"
                  :error-messages="errorField.companyAddress"
                  clearable
                ></v-text-field>
              </div>
            </div>

            <div
              class="form-row form-row--subscription"
              v-if="!paymentChannelDisabled"
            >
              <label class="form-label">Subscription Period</label>
              <div class="form-field form-field--inline">
                <v-menu
                  ref="menuSubscriptionStartDate"
                  v-model="menuSubscriptionStartDate"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      filled
                      v-model="
                        companyDetails.finalSubscriptionStartDate
                      "
                      :error-messages="
                        errorField.finalSubscriptionStartDate
                      "
                      label="Subscription Start Date (YYYY-MM-DD)"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="companyDetails.finalSubscriptionStartDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menuSubscriptionStartDate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.menuSubscriptionStartDate.save(date)
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <span class="form-field__separator">to</span>
                <v-menu
                  ref="menuSubscriptionEndDate"
                  v-model="menuSubscriptionEndDate"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      filled
                      v-model="companyDetails.finalSubscriptionEndDate"
                      :error-messages="
                        errorField.finalSubscriptionEndDate
                      "
                      label="Subscription End Date (YYYY-MM-DD)"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="companyDetails.finalSubscriptionEndDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menuSubscriptionEndDate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuSubscriptionEndDate.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>

            <div class="section-divider"></div>

            <div class="form-row">
              <label class="form-label">Client PIC Name</label>
              <div class="form-field">
                <div class="edit-taginput" v-click-outside="() => picNameDropdownOpen = false">
                  <div
                    class="edit-taginput__trigger"
                    :class="{ 'edit-taginput__trigger--open': picNameDropdownOpen, 'edit-taginput__trigger--error': errorField.picName }"
                    @click="picNameDropdownOpen = true"
                  >
                    <div class="edit-taginput__chips">
                      <span
                        v-for="(val, i) in companyDetails.picName"
                        :key="'picName-' + i"
                        class="edit-taginput__chip"
                      >
                        {{ val }}
                        <button
                          class="edit-taginput__chip-remove"
                          @click.stop="removePicName(i)"
                        >
                          <v-icon size="14" color="var(--app-text-muted)">mdi-close</v-icon>
                        </button>
                      </span>
                      <input
                        type="text"
                        class="edit-taginput__input"
                        v-model="picNameInput"
                        placeholder=""
                        @keydown.enter.prevent="addPicNameTag()"
                        @keydown.tab.prevent="addPicNameTag()"
                        @input="picNameDropdownOpen = true"
                        @focus="picNameDropdownOpen = true"
                      />
                    </div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <div class="edit-taginput__info" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-taginput__info-icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                          </svg>
                        </div>
                      </template>
                      <span>Press <kbd>enter/tab</kbd> to insert multiple</span>
                    </v-tooltip>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': picNameDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="picNameDropdownOpen && filteredPicNameItems.length > 0" class="edit-select__dropdown">
                    <div
                      v-for="(item, idx) in filteredPicNameItems"
                      :key="'picNameOpt-' + idx"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': companyDetails.picName.indexOf(item) !== -1 }"
                      @click="selectPicNameSuggestion(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <div v-if="errorField.picName" class="edit-select__error">
                    <template v-if="Array.isArray(errorField.picName)">
                      <div v-for="(msg, idx) in errorField.picName" :key="'picNameErr-' + idx" class="edit-select__error-item">{{ msg }}</div>
                    </template>
                    <template v-else>{{ errorField.picName }}</template>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Client PIC Email</label>
              <div class="form-field">
                <div class="edit-taginput" v-click-outside="() => picEmailDropdownOpen = false">
                  <div
                    class="edit-taginput__trigger"
                    :class="{ 'edit-taginput__trigger--open': picEmailDropdownOpen, 'edit-taginput__trigger--error': errorField.picEmail }"
                    @click="picEmailDropdownOpen = true"
                  >
                    <div class="edit-taginput__chips">
                      <span
                        v-for="(val, i) in companyDetails.picEmail"
                        :key="'picEmail-' + i"
                        class="edit-taginput__chip"
                      >
                        {{ val }}
                        <button
                          class="edit-taginput__chip-remove"
                          @click.stop="removePicEmail(i)"
                        >
                          <v-icon size="14" color="var(--app-text-muted)">mdi-close</v-icon>
                        </button>
                      </span>
                      <input
                        type="text"
                        class="edit-taginput__input"
                        v-model="picEmailInput"
                        placeholder=""
                        @keydown.enter.prevent="addPicEmailTag()"
                        @keydown.tab.prevent="addPicEmailTag()"
                        @input="picEmailDropdownOpen = true"
                        @focus="picEmailDropdownOpen = true"
                      />
                    </div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <div class="edit-taginput__info" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-taginput__info-icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                          </svg>
                        </div>
                      </template>
                      <span>Press <kbd>enter/tab</kbd> to insert multiple</span>
                    </v-tooltip>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': picEmailDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="picEmailDropdownOpen && filteredPicEmailItems.length > 0" class="edit-select__dropdown">
                    <div
                      v-for="(item, idx) in filteredPicEmailItems"
                      :key="'picEmailOpt-' + idx"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': companyDetails.picEmail.indexOf(item) !== -1 }"
                      @click="selectPicEmailSuggestion(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <div v-if="errorField.picEmail" class="edit-select__error">
                    <template v-if="Array.isArray(errorField.picEmail)">
                      <div v-for="(msg, idx) in errorField.picEmail" :key="'picEmailErr-' + idx" class="edit-select__error-item">{{ msg }}</div>
                    </template>
                    <template v-else>{{ errorField.picEmail }}</template>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Client PIC Contact No</label>
              <div class="form-field">
                <div class="edit-taginput" v-click-outside="() => picContactDropdownOpen = false">
                  <div
                    class="edit-taginput__trigger"
                    :class="{ 'edit-taginput__trigger--open': picContactDropdownOpen, 'edit-taginput__trigger--error': errorField.picContactNo }"
                    @click="picContactDropdownOpen = true"
                  >
                    <div class="edit-taginput__chips">
                      <span
                        v-for="(val, i) in companyDetails.picContactNo"
                        :key="'picContact-' + i"
                        class="edit-taginput__chip"
                      >
                        {{ val }}
                        <button
                          class="edit-taginput__chip-remove"
                          @click.stop="removePicContact(i)"
                        >
                          <v-icon size="14" color="var(--app-text-muted)">mdi-close</v-icon>
                        </button>
                      </span>
                      <input
                        type="text"
                        class="edit-taginput__input"
                        v-model="picContactInput"
                        placeholder=""
                        @keydown.enter.prevent="addPicContactTag()"
                        @keydown.tab.prevent="addPicContactTag()"
                        @input="picContactDropdownOpen = true"
                        @focus="picContactDropdownOpen = true"
                      />
                    </div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <div class="edit-taginput__info" v-on="on">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-taginput__info-icon">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                          </svg>
                        </div>
                      </template>
                      <span>Press <kbd>enter/tab</kbd> to insert multiple</span>
                    </v-tooltip>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': picContactDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="picContactDropdownOpen && filteredPicContactItems.length > 0" class="edit-select__dropdown">
                    <div
                      v-for="(item, idx) in filteredPicContactItems"
                      :key="'picContactOpt-' + idx"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': companyDetails.picContactNo.indexOf(item) !== -1 }"
                      @click="selectPicContactSuggestion(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <div v-if="errorField.picContactNo" class="edit-select__error">
                    <template v-if="Array.isArray(errorField.picContactNo)">
                      <div v-for="(msg, idx) in errorField.picContactNo" :key="'picContactErr-' + idx" class="edit-select__error-item">{{ msg }}</div>
                    </template>
                    <template v-else>{{ errorField.picContactNo }}</template>
                  </div>
                </div>
              </div>
            </div>

            <div class="section-divider"></div>

            <div class="form-row">
              <label class="form-label">Bank Name</label>
              <div class="form-field">
                <v-text-field
                  filled
                  dense
                  v-model="applicationDetails.bankUuid"
                  :error-messages="errorField.bankUuid"
                  clearable
                  :disabled="paymentChannelDisabled"
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Bank Account No</label>
              <div class="form-field">
                <v-text-field
                  filled
                  dense
                  v-model="applicationDetails.bankAccNo"
                  :error-messages="errorField.bankAccNo"
                  :disabled="paymentChannelDisabled"
                  clearable
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Bank Account Holder Name</label>
              <div class="form-field">
                <v-text-field
                  filled
                  dense
                  v-model="applicationDetails.bankAccHolderName"
                  :error-messages="errorField.bankAccHolderName"
                  :disabled="paymentChannelDisabled"
                  clearable
                ></v-text-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT COLUMN -->
      <div class="cards-column">
        <!-- Application Details -->
        <div class="section-card">
          <div class="section-header">
            <v-icon color="white" small>mdi-application-edit-outline</v-icon>
            <span class="section-header__title">Application Details</span>
          </div>
          <div class="section-body">
            <div class="form-row">
              <label class="form-label">Programme Name</label>
              <div class="form-field">
                <v-text-field
                  v-model="applicationDetails.programmeName"
                  :error-messages="errorField.programmeName"
                  filled
                  dense
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">taxPOD Pricing (Applicant)</label>
              <div class="form-field">
                <v-text-field
                  disabled
                  v-model="
                    companyDetails.taxpodPricingFilledByApplicant
                  "
                  :error-messages="
                    errorField.taxpodPricingFilledByApplicant
                  "
                  filled
                  dense
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">taxPOD Pricing</label>
              <div class="form-field">
                <v-text-field
                  v-model="companyDetails.taxpodPricing"
                  :error-messages="errorField.taxpodPricing"
                  filled
                  dense
                  clearable
                  hide-spin-buttons
                  type="number"
                  label="etc: 2888, 2388, 1998, ..."
                  @input="updateProgrammeName()"
                  @wheel="$event.target.blur()"
                  @keydown.up.prevent
                  @keydown.down.prevent
                ></v-text-field>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">taxPOD Type</label>
              <div class="form-field">
                <div class="edit-select" v-click-outside="() => taxpodTypeDropdownOpen = false">
                  <div
                    class="edit-select__trigger"
                    :class="{ 'edit-select__trigger--open': taxpodTypeDropdownOpen }"
                    @click="taxpodTypeDropdownOpen = !taxpodTypeDropdownOpen"
                  >
                    <div class="edit-select__value">
                      <span v-if="applicationDetails.taxpodType !== null && applicationDetails.taxpodType !== undefined">
                        {{ (taxpodTypeItems.find(i => i.value === applicationDetails.taxpodType) || {}).text || '' }}
                      </span>
                      <span v-else class="edit-select__placeholder">Select taxPOD type...</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': taxpodTypeDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="taxpodTypeDropdownOpen" class="edit-select__dropdown">
                    <div
                      v-for="item in taxpodTypeItems"
                      :key="item.value"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': applicationDetails.taxpodType === item.value }"
                      @click="selectTaxpodType(item.value)"
                    >
                      {{ item.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Payment Channel</label>
              <div class="form-field">
                <div class="edit-select" v-click-outside="() => paymentChannelDropdownOpen = false">
                  <div
                    class="edit-select__trigger"
                    :class="{ 'edit-select__trigger--open': paymentChannelDropdownOpen }"
                    @click="paymentChannelDropdownOpen = !paymentChannelDropdownOpen"
                  >
                    <div class="edit-select__value">
                      <span v-if="applicationDetails.paymentChannel !== null && applicationDetails.paymentChannel !== undefined">
                        {{ (paymentChannelItems.find(i => i.value === applicationDetails.paymentChannel) || {}).text || '' }}
                      </span>
                      <span v-else class="edit-select__placeholder">Select payment channel...</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': paymentChannelDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="paymentChannelDropdownOpen" class="edit-select__dropdown">
                    <div
                      v-for="item in paymentChannelItems"
                      :key="item.value"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': applicationDetails.paymentChannel === item.value }"
                      @click="selectPaymentChannel(item.value)"
                    >
                      {{ item.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row" v-if="!paymentChannelDisabled">
              <label class="form-label">Payment Mode</label>
              <div class="form-field">
                <div class="edit-select" v-click-outside="() => paymentModeDropdownOpen = false">
                  <div
                    class="edit-select__trigger"
                    :class="{ 'edit-select__trigger--open': paymentModeDropdownOpen, 'edit-select__trigger--error': errorField.paymentMode }"
                    @click="paymentModeDropdownOpen = !paymentModeDropdownOpen"
                  >
                    <div class="edit-select__value">
                      <span v-if="applicationDetails.paymentMode">{{ applicationDetails.paymentMode }}</span>
                      <span v-else class="edit-select__placeholder">Select payment mode...</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': paymentModeDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="paymentModeDropdownOpen" class="edit-select__dropdown">
                    <div
                      v-for="item in paymentMode"
                      :key="item"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': applicationDetails.paymentMode === item }"
                      @click="selectPaymentMode(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
                <div v-if="errorField.paymentMode" class="edit-select__error">
                  <template v-if="Array.isArray(errorField.paymentMode)">
                    <div v-for="(msg, idx) in errorField.paymentMode" :key="'paymentModeErr-' + idx" class="edit-select__error-item">{{ msg }}</div>
                  </template>
                  <template v-else>{{ errorField.paymentMode }}</template>
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Screenshot of Bank Account for Refund</label>
              <div class="form-field">
                <div
                  v-cloak
                  @drop.prevent="addDropFile($event, 'ssOfBankAcc')"
                  @dragover.prevent
                  class="w-100"
                >
                  <v-file-input
                    :prepend-icon="null"
                    prepend-inner-icon="mdi-paperclip"
                    dense
                    filled
                    small-chips
                    v-model="applicationDetails.ssOfBankAcc"
                    :error-messages="errorField.ssOfBankAcc"
                    :truncate-length="1000"
                    :disabled="paymentChannelDisabled"
                  ></v-file-input>
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Is Application Duplicate</label>
              <div class="form-field">
                <div class="edit-select" v-click-outside="() => isDuplicateDropdownOpen = false">
                  <div
                    class="edit-select__trigger"
                    :class="{ 'edit-select__trigger--open': isDuplicateDropdownOpen }"
                    @click="isDuplicateDropdownOpen = !isDuplicateDropdownOpen"
                  >
                    <div class="edit-select__value">
                      <span v-if="applicationDetails.isApplicationDuplicate !== null && applicationDetails.isApplicationDuplicate !== undefined">
                        {{ (isDuplicateItems.find(i => i.value === applicationDetails.isApplicationDuplicate) || {}).text || '' }}
                      </span>
                      <span v-else class="edit-select__placeholder">Select...</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': isDuplicateDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="isDuplicateDropdownOpen" class="edit-select__dropdown">
                    <div
                      v-for="item in isDuplicateItems"
                      :key="String(item.value)"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': applicationDetails.isApplicationDuplicate === item.value }"
                      @click="selectIsDuplicate(item.value)"
                    >
                      {{ item.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Move application to</label>
              <div class="form-field">
                <div class="edit-select" v-click-outside="() => moveStageDropdownOpen = false">
                  <div
                    class="edit-select__trigger"
                    :class="{ 'edit-select__trigger--open': moveStageDropdownOpen }"
                    @click="moveStageDropdownOpen = !moveStageDropdownOpen"
                  >
                    <div class="edit-select__value">
                      <span v-if="applicationDetails.moveApplicationStage !== null && applicationDetails.moveApplicationStage !== undefined">
                        {{ (applicationStages.find(i => i.value === applicationDetails.moveApplicationStage) || {}).text || '' }}
                      </span>
                      <span v-else class="edit-select__placeholder">Select stage...</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': moveStageDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="moveStageDropdownOpen" class="edit-select__dropdown">
                    <div
                      v-for="item in applicationStages"
                      :key="item.value"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': applicationDetails.moveApplicationStage === item.value }"
                      @click="selectMoveStage(item.value)"
                    >
                      {{ item.text }}
                    </div>
                    <div v-if="applicationStages.length === 0" class="edit-select__empty">
                      No stages available
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="section-divider"></div>

            <div class="form-row">
              <label class="form-label">Responder Email</label>
              <div class="form-field">
                <div class="edit-select" v-click-outside="() => responderEmailDropdownOpen = false">
                  <div
                    class="edit-select__trigger"
                    :class="{ 'edit-select__trigger--open': responderEmailDropdownOpen }"
                    @click="responderEmailDropdownOpen = !responderEmailDropdownOpen"
                  >
                    <div class="edit-select__value" v-if="!responderEmailDropdownOpen">
                      <span v-if="applicationDetails.referByEmail">{{ applicationDetails.referByEmail }}</span>
                      <span v-else class="edit-select__placeholder">Select responder email...</span>
                    </div>
                    <input
                      v-if="responderEmailDropdownOpen"
                      type="text"
                      class="edit-search__input"
                      v-model="responderEmailSearch"
                      placeholder="Search responder email..."
                      @click.stop
                      @input="responderEmailDropdownOpen = true"
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': responderEmailDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="responderEmailDropdownOpen" class="edit-select__dropdown">
                    <div
                      v-for="(item, idx) in filteredSalespersonData"
                      :key="'responder-' + idx"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': applicationDetails.referByEmail === item }"
                      @click="selectResponderEmail(item)"
                    >
                      {{ item }}
                    </div>
                    <div v-if="filteredSalespersonData.length === 0" class="edit-select__empty">
                      No results found
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <label class="form-label">Responder Name</label>
              <div class="form-field">
                <v-text-field
                  v-model="applicationDetails.referByName"
                  :error-messages="errorField.referByName"
                  filled
                  dense
                  disabled
                  label="Responder Name"
                ></v-text-field>
              </div>
            </div>
          </div>
        </div>

        <!-- Enrollment Details -->
        <div class="section-card" v-if="paymentChannelDisabled">
          <div class="section-header">
            <v-icon color="white" small>mdi-form-select</v-icon>
            <span class="section-header__title">Enrollment Details</span>
          </div>
          <div class="section-body">
            <div>
              <div class="enrollment-row">
                <div class="enrollment-col">
                  <label class="form-label">First Name</label>
                  <div class="form-field">
                    <v-text-field
                      v-model="enrollmentDetails.firstNameAccEnrollment"
                      :error-messages="errorField.firstNameAccEnrollment"
                      filled
                      dense
                      clearable
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </div>
                <div class="enrollment-col">
                  <label class="form-label">Last Name</label>
                  <div class="form-field">
                    <v-text-field
                      v-model="enrollmentDetails.lastNameAccEnrollment"
                      :error-messages="errorField.lastNameAccEnrollment"
                      filled
                      dense
                      clearable
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </div>
              </div>

              <div class="enrollment-row">
                <div class="enrollment-col">
                  <label class="form-label">Contact No</label>
                  <div class="form-field">
                    <v-text-field
                      v-model="enrollmentDetails.contactNoAccEnrollment"
                      :error-messages="errorField.contactNoAccEnrollment"
                      filled
                      dense
                      clearable
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </div>
                <div class="enrollment-col">
                  <label class="form-label">Email</label>
                  <div class="form-field">
                    <v-text-field
                      v-model="enrollmentDetails.emailAccEnrollment"
                      :error-messages="errorField.emailAccEnrollment"
                      filled
                      dense
                      clearable
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-for="(inputData, index) in dynamicEnrollmentDetails"
              :key="index"
            >
              <div class="section-divider"></div>

              <div class="enrollment-row">
                <div class="enrollment-col">
                  <label class="form-label">First Name</label>
                  <div class="form-field">
                    <v-text-field
                      v-model="inputData.firstNameAccEnrollment"
                      :rules="[rules.required]"
                      filled
                      dense
                      clearable
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </div>
                <div class="enrollment-col">
                  <label class="form-label">Last Name</label>
                  <div class="form-field">
                    <v-text-field
                      v-model="inputData.lastNameAccEnrollment"
                      :rules="[rules.required]"
                      filled
                      dense
                      clearable
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </div>
              </div>

              <div class="enrollment-row">
                <div class="enrollment-col">
                  <label class="form-label">Contact No</label>
                  <div class="form-field">
                    <v-text-field
                      v-model="inputData.contactNoAccEnrollment"
                      :rules="[rules.required]"
                      filled
                      dense
                      clearable
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </div>
                <div class="enrollment-col">
                  <label class="form-label">Email</label>
                  <div class="form-field">
                    <v-text-field
                      v-model="inputData.emailAccEnrollment"
                      :rules="[rules.required, rules.email]"
                      filled
                      dense
                      clearable
                      hide-spin-buttons
                    ></v-text-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="enrollment-actions">
              <button
                class="enrollment-action-btn enrollment-action-btn--add"
                @click="addEnrollmentDetails()"
              >
                <v-icon dark small>mdi-plus</v-icon>
              </button>
              <button
                v-if="dynamicEnrollmentDetails.length > 0"
                class="enrollment-action-btn enrollment-action-btn--remove"
                @click="removeEnrollmentDetails()"
              >
                <v-icon dark small>mdi-minus</v-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Customer Service Details -->
        <div class="section-card">
          <div class="section-header">
            <v-icon color="white" small>mdi-face-agent</v-icon>
            <span class="section-header__title">Customer Service Details</span>
          </div>
          <div class="section-body">
            <div class="form-row">
              <label class="form-label">Customer Service</label>
              <div class="form-field">
                <div class="edit-select" v-click-outside="() => csDropdownOpen = false">
                  <div
                    class="edit-select__trigger"
                    :class="{ 'edit-select__trigger--open': csDropdownOpen, 'edit-select__trigger--error': errorField.customerService }"
                    @click="csDropdownOpen = !csDropdownOpen"
                  >
                    <div class="edit-select__value">
                      <span
                        v-for="(val, i) in csDetails.customerService"
                        :key="'cs-' + i"
                        class="edit-taginput__chip"
                      >
                        {{ getCsText(val) }}
                        <button
                          class="edit-taginput__chip-remove"
                          @click.stop="removeCustomerService(i)"
                        >
                          <v-icon size="14" color="var(--app-text-muted)">mdi-close</v-icon>
                        </button>
                      </span>
                      <span v-if="!csDetails.customerService || csDetails.customerService.length === 0" class="edit-select__placeholder">Select customer service...</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="edit-select__arrow" :class="{ 'edit-select__arrow--open': csDropdownOpen }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                  <div v-if="csDropdownOpen" class="edit-select__dropdown">
                    <div
                      v-for="(item, idx) in csDetails.customerServiceData"
                      :key="'csOpt-' + idx"
                      class="edit-select__option"
                      :class="{ 'edit-select__option--selected': isCsSelected(item.value) }"
                      @click="toggleCustomerService(item)"
                    >
                      <span class="edit-select__checkbox" :class="{ 'edit-select__checkbox--checked': isCsSelected(item.value) }">
                        <v-icon v-if="isCsSelected(item.value)" size="14" color="#fff">mdi-check</v-icon>
                      </span>
                      {{ item.text }}
                    </div>
                    <div v-if="csDetails.customerServiceData.length === 0" class="edit-select__empty">
                      No customer service available
                    </div>
                  </div>
                  <div v-if="errorField.customerService" class="edit-select__error">
                    <template v-if="Array.isArray(errorField.customerService)">
                      <div v-for="(msg, idx) in errorField.customerService" :key="'csErr-' + idx" class="edit-select__error-item">{{ msg }}</div>
                    </template>
                    <template v-else>{{ errorField.customerService }}</template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Page Loading State -->
    <div v-if="loadingDialog" class="page-loader">
      <div class="page-loader__skeleton">
        <div class="skel-header">
          <div class="skel-line skel-line--lg"></div>
          <div class="skel-line skel-line--sm"></div>
        </div>
        <div class="skel-grid">
          <div class="skel-card" v-for="n in 4" :key="n">
            <div class="skel-card__header"></div>
            <div class="skel-card__body">
              <div class="skel-line skel-line--md"></div>
              <div class="skel-line skel-line--full"></div>
              <div class="skel-line skel-line--lg"></div>
              <div class="skel-line skel-line--md"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <HrdcLoader :loadingDialog="loadingDialog"></HrdcLoader>

    <!-- Loading Bar Dialog -->
    <v-dialog v-model="loadingBar" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc/objects/globalData";

export default {
  mixins: [hrdcFunction],
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
    paymentChannelDisabled() {
      let disabled = false;
      if (this.applicationDetails.paymentChannel == 2) {
        disabled = true;
      }

      return disabled;
    },
    filteredPicNameItems() {
      var search = (this.picNameInput || '').toLowerCase();
      if (!search) return this.companyDetails.picNameItems || [];
      return (this.companyDetails.picNameItems || []).filter(function(item) {
        return item.toLowerCase().indexOf(search) !== -1;
      });
    },
    filteredPicEmailItems() {
      var search = (this.picEmailInput || '').toLowerCase();
      if (!search) return this.companyDetails.picEmailItems || [];
      return (this.companyDetails.picEmailItems || []).filter(function(item) {
        return item.toLowerCase().indexOf(search) !== -1;
      });
    },
    filteredPicContactItems() {
      var search = (this.picContactInput || '').toLowerCase();
      if (!search) return this.companyDetails.picContactNoItems || [];
      return (this.companyDetails.picContactNoItems || []).filter(function(item) {
        return item.toLowerCase().indexOf(search) !== -1;
      });
    },
    filteredSalespersonData() {
      var search = (this.responderEmailSearch || '').toLowerCase();
      if (!search) return this.csDetails.salespersonData || [];
      return (this.csDetails.salespersonData || []).filter(function(item) {
        return item.toLowerCase().indexOf(search) !== -1;
      });
    },
  },
  props: ["params"],
  data: () => ({
    apiGetApplicationDetails: new Api(),
    apiEditApplication: new Api(),
    apiGetCsAndSalespersonList: new Api(),
    model: new Model(),
    hrdcData: new HrdcData(),
    service: new Service(),
    allStages: [],
    loadingDialog: false,
    loadingBar: false,
    panel: [0, 1, 2, 3, 4, 5, 6, 7],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menu2: false,
    companyDetails: {
      companyUuid: null,
      companyId: null,
      oriCompanyName: null,
      oldCompanyName: null,
      companySsmNo: null,
      companyTinNo: null,
      companyAddress: null,
      picName: [],
      picNameItems: [],
      picEmail: [],
      picEmailItems: [],
      picContactNo: [],
      picContactNoItems: [],
      bankUuid: null,
      bankAccNo: null,
      bankAccHolderName: null,
      taxpodPricingFilledByApplicant: null,
      taxpodPricing: null,
      oriBankUuid: null,
      oriBankAccNo: null,
      oriBankAccHolderName: null,
      finalSubscriptionStartDate: null,
      finalSubscriptionEndDate: null,
    },
    errorField: {
      companyUuid: null,
      companyId: null,
      oriCompanyName: null,
      oldCompanyName: null,
      companySsmNo: null,
      companyTinNo: null,
      companyAddress: null,
      picName: null,
      picContactNo: null,
      bankUuid: null,
      bankAccNo: null,
      bankAccHolderName: null,
      customerService: null,
      taxpodPricingFilledByApplicant: null,
      taxpodPricing: null,
      programmeName: null,
      paymentMode: null,
      referByName: null,
      referByEmail: null,
      subscriptionStartDate: null,
      finalSubscriptionStartDate: null,
      finalSubscriptionEndDate: null,
    },
    salespersonDetails: {
      salespersonName: null,
      salespersonEmail: null,
      salespersonContactNo: null,
    },
    csDetails: {
      customerService: null,
      customerServiceData: [],
      salespersonData: [],
    },
    applicationDetails: {
      paymentChannel: null,
      taxpodType: null,
      ssOfBankAcc: null,
      oriSsOfBankAcc: null,
      programmeName: null,
      paymentMode: null,
      referByName: null,
      referByEmail: null,
      isApplicationDuplicate: false,
      bankUuid: null,
      bankAccNo: null,
      bankAccHolderName: null,
      moveApplicationStage: null,
    },
    enrollmentDetails: {
      firstNameAccEnrollment: null,
      lastNameAccEnrollment: null,
      contactNoAccEnrollment: null,
      emailAccEnrollment: null,
    },
    alertEditApplicationDialog: false,
    visionApiUrl: null,
    visionApiAuthorization: null,
    companyData: null,
    isPricingCorrect: false,
    isPaymentMade: null,
    taxpodType: null,
    dynamicEnrollmentDetails: [],
    oriDynamicEnrollmentDetails: [],
    dynamicEnrollmentCount: 0,
    rules: {
      required: (value) => !!value || "Required.",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
    paymentMode: ["Stripe", "Credit card", "Bank transfer", "Cheque"],
    salespersonData: [],
    menuSubscriptionStartDate: false,
    menuSubscriptionEndDate: false,
    applicationStages: [],
    taxpodTypeDropdownOpen: false,
    paymentChannelDropdownOpen: false,
    paymentModeDropdownOpen: false,
    isDuplicateDropdownOpen: false,
    moveStageDropdownOpen: false,
    picNameInput: '',
    picNameDropdownOpen: false,
    picEmailInput: '',
    picEmailDropdownOpen: false,
    picContactInput: '',
    picContactDropdownOpen: false,
    responderEmailSearch: '',
    responderEmailDropdownOpen: false,
    csDropdownOpen: false,
    taxpodTypeItems: [
      { text: 'New Sale', value: 1 },
      { text: 'Renewal', value: 2 },
    ],
    paymentChannelItems: [
      { text: 'Pay & Refund', value: 1 },
      { text: 'Claim Basis', value: 2 },
    ],
    isDuplicateItems: [
      { text: 'Yes', value: true },
      { text: 'No', value: false },
    ],
  }),
  async created() {
    this.loadingDialog = !this.loadingDialog;
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    this.allStages = await this.hrdcData.allStages;
    this.visionApiUrl = process.env.VUE_APP_API_URL_VISION;
    this.visionApiAuthorization = this.VUE_APP_API_AUTHORIZATION_VISION;
    this.rolesAssignation(this.auth.roles);

    // Assign editable stages.
    this.applicationStages = this.$store.state.hrdc.publicViews.map((view) => {
      const filterValue = JSON.parse(view.filterCondition).find(x => x.field === "stages").value;

      return {
        text: view.name,
        value: filterValue,
      };
    });

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiGetApplicationDetails: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-application-details`,
        method: "post",
        params: {
          applicationUuid: this.$route.query._ausk,
          type: "MULTIPLE_ENROLLMENT_DETAILS",
        },
      },
      apiEditApplication: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/edit-application`,
        method: "post",
      },
      apiGetCsAndSalespersonList: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-cs-and-salesperson-list`,
        method: "post",
        params: {
          internalRoleSlugs: ["taxpod-customer-service"],
        },
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
      if (apiDetails[api].headers !== undefined) {
        this[api].setHeaders(apiDetails[api].headers);
      }
    }

    this.apiGetApplicationDetails.fetch();
    this.apiGetApplicationDetails.setCallbackCompleted((response) => {
      try {
        const datas = response.data;

        if (!response.status) {
          this.$store.commit("assignDeveloperData", {
            paginationPageNo: this.$route.query.currentPageNo,
          });

          this.$router.push({
            name: "HrdcApplication",
            query: {
              viewId: this.$store.state.hrdc.data.viewId,
              tabIndex: 0,
            },
          });
          this.$store.dispatch("showMessage", {
            message: datas,
            messageType: "error",
            timeout: 2000,
          });
          return;
        }

        // Just take first row to display basic info.
        const data = response.data[0];

        if (!this.staticTaxpodPricing.includes(data.totalPrice)) {
          this.isPricingCorrect = true;
        }

        // Company details.
        this.companyDetails = this.transformCompanyDetails(data, response);

        // Application Details.
        this.applicationDetails.paymentChannel = data.paymentChannel;
        this.applicationDetails.taxpodType = data.taxpodType;
        this.applicationDetails.programmeName = data.programmeName;
        this.applicationDetails.paymentMode = data.paymentMode;
        this.applicationDetails.referByName = data.referByName;
        this.applicationDetails.referByEmail = data.referByEmail;
        this.applicationDetails.isApplicationDuplicate =
          data.isApplicationDuplicate;
        this.applicationDetails.bankUuid = data.applicationBankUuid;
        this.applicationDetails.bankAccNo = data.applicationOldBankAccount;
        this.applicationDetails.bankAccHolderName =
          data.applicationOldBankAccountHolderName;

        for (const item of response.attachments) {
          // Create a Blob object from the data
          const blob = new Blob([new Uint8Array(item.dataArray)]);

          // Create the File object
          const file = new File([blob], item.fileName, {
            type: `application/${item.extension}`,
          });

          if (item.type == "Screenshot of Bank Account Details for Refund") {
            this.applicationDetails.ssOfBankAcc = file;
            this.applicationDetails.oriSsOfBankAcc = file;
          }
        }

        // Salesperson details.
        this.salespersonDetails.salespersonName = data.salesperson.name ?? "-";
        this.salespersonDetails.salespersonEmail =
          data.salesperson.email ?? "-";
        this.salespersonDetails.salespersonContactNo =
          data.salesperson.mobile ?? "-";

        // Customer Service details.
        const csArrTmp = [];
        if (response.applicationCs.length > 0) {
          for (const customerService of response.applicationCs) {
            csArrTmp.push({
              text: customerService.csEmail,
              value: customerService.csUuid,
            });
          }
          this.csDetails.customerService = csArrTmp;
        }

        // Enrollment details.
        this.enrollmentDetails.firstNameAccEnrollment =
          data.firstNameAccEnrollment;
        this.enrollmentDetails.lastNameAccEnrollment =
          data.lastNameAccEnrollment;
        this.enrollmentDetails.contactNoAccEnrollment =
          data.contactNoAccEnrollment;
        this.enrollmentDetails.emailAccEnrollment = data.emailAccEnrollment;

        // Dynamic Enrollment details.
        if (response.dynamicEnrollmentDetails.length > 0) {
          this.dynamicEnrollmentDetails = response.dynamicEnrollmentDetails.map(
            (enrollmentDetail) => ({
              firstNameAccEnrollment: enrollmentDetail.firstNameAccEnrollment,
              lastNameAccEnrollment: enrollmentDetail.lastNameAccEnrollment,
              contactNoAccEnrollment: enrollmentDetail.contactNoAccEnrollment,
              emailAccEnrollment: enrollmentDetail.emailAccEnrollment,
            })
          );

          this.oriDynamicEnrollmentDetails = [...this.dynamicEnrollmentDetails];
        }

        // Check whether company exists in vision or not.
        this.isPaymentMade = data.isPaymentMade;
        this.taxpodType = data.taxpodType;

        // Get CS Listing.
        this.apiGetCsAndSalespersonList.setCallbackCompleted((response) => {
          try {
            const { data, status, salespersonData } = response;

            if (status) {
              // Handle if sso server down, just display empty items for cs lists.
              if (data) {
                for (const item of data) {
                  this.csDetails.customerServiceData.push({
                    text: item.email,
                    value: item.uuid,
                  });
                }
              }

              if (salespersonData) {
                this.salespersonData = salespersonData;
                for (const salespersonItem of salespersonData) {
                  this.csDetails.salespersonData.push(salespersonItem.email);
                }
              }
            }
            this.loadingDialog = !this.loadingDialog;
          } catch (err) {
            console.log(err);
          }
        });
        this.apiGetCsAndSalespersonList.fetch();
      } catch (err) {
        console.log(err);
      }
    });
  },
  mounted() {},
  methods: {
    formatNumber(number) {
      if (number) {
        return number.toFixed(2);
      }
    },
    isArrayofObjects(arr) {
      if (arr !== null) {
        return (
          arr.length > 0 &&
          typeof arr[0] === "object" &&
          arr[0] !== null &&
          !Array.isArray(arr[0])
        );
      }
    },
    changePaymentChannel() {
      this.clearErrorMsg();
      if (this.applicationDetails.paymentChannel == 1) {
        this.companyDetails.bankUuid = this.companyDetails.oriBankUuid;
        this.companyDetails.bankAccNo = this.companyDetails.oriBankAccNo;
        this.companyDetails.bankAccHolderName =
          this.companyDetails.oriBankAccHolderName;
        this.applicationDetails.ssOfBankAcc =
          this.applicationDetails.oriSsOfBankAcc;
      } else {
        this.companyDetails.bankUuid = null;
        this.companyDetails.bankAccNo = null;
        this.companyDetails.bankAccHolderName = null;
        this.applicationDetails.ssOfBankAcc = null;
      }
    },
    updateProgrammeName() {
      let taxpodPricing = Number(this.companyDetails.taxpodPricing);

      // Get base pricing.
      taxpodPricing = this.getTaxpodBasePricing(taxpodPricing);
      const programmeNameObj = this.staticTaxpodData.find(
        (item) => item.price == taxpodPricing
      );
      if (programmeNameObj) {
        this.applicationDetails.programmeName = `taxPOD Masterclass ${programmeNameObj.flyer}`;
      }
    },
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = response.data[key];
      }
    },
    addEnrollmentDetails() {
      if (this.dynamicEnrollmentCount < 0) {
        this.dynamicEnrollmentCount = 1;
      }

      // Find whether got index of dynamic enrollment details or not.
      const enrollmentDetail =
        this.oriDynamicEnrollmentDetails[this.dynamicEnrollmentCount - 1];

      this.dynamicEnrollmentDetails.push({
        firstNameAccEnrollment:
          enrollmentDetail?.firstNameAccEnrollment || null,
        lastNameAccEnrollment: enrollmentDetail?.lastNameAccEnrollment || null,
        contactNoAccEnrollment:
          enrollmentDetail?.contactNoAccEnrollment || null,
        emailAccEnrollment: enrollmentDetail?.emailAccEnrollment || null,
      });

      this.dynamicEnrollmentCount++;
    },
    removeEnrollmentDetails() {
      this.dynamicEnrollmentDetails.pop();
      this.dynamicEnrollmentCount--;
    },
    // Create function to capture original company data.
    transformCompanyDetails(data, response) {
      let bankAccNo =
        data.oldBankAccount && data.oldBankAccount !== "null"
          ? data.oldBankAccount.replace(/\s+/g, "")
          : data.applicationOldBankAccount?.replace(/\s+/g, "") || null;

      let bankAccHolderName =
        data.oldBankAccountHolderName &&
        data.oldBankAccountHolderName !== "null"
          ? data.oldBankAccountHolderName
          : data.applicationOldBankAccountHolderName || null;

      return {
        companyUuid: data.companyUuid,
        companyId: `${data.oldCompanyId}`,
        oriCompanyName: `${data.oriCompanyName}`,
        oldCompanyName: `${data.oldCompanyName}`,
        companySsmNo: data.oldSsmNo,
        companyTinNo: data.companyTinNo,
        companyAddress: data.oldAddress,
        picName: response.companyPicData
          .map((item) => item.picName)
          .filter((item) => item !== null),
        picNameItems: response.companyPicData
          .map((item) => item.picName)
          .filter((item) => item !== null),
        picEmail: response.companyPicData
          .map((item) => item.picEmail)
          .filter((item) => item !== null),
        picEmailItems: response.companyPicData
          .map((item) => item.picEmail)
          .filter((item) => item !== null),
        picContactNo: response.companyPicData
          .map((item) => item.picContactNo)
          .filter((item) => item !== null),
        picContactNoItems: response.companyPicData
          .map((item) => item.picContactNo)
          .filter((item) => item !== null),
        bankUuid: data.bankUuid ?? data.applicationBankUuid ?? null,
        bankAccNo,
        bankAccHolderName,
        oriBankUuid: data.bankUuid ?? data.applicationBankUuid ?? null,
        oriBankAccNo: bankAccNo,
        oriBankAccHolderName: bankAccHolderName,
        taxpodPricingFilledByApplicant: isNaN(parseFloat(data.oriPrice)) ? null : parseFloat(data.oriPrice).toFixed(2),
        taxpodPricing: data.totalPrice,
        finalSubscriptionStartDate: data.subscriptionStartDate !== "Invalid date" ? data.subscriptionStartDate : null,
        finalSubscriptionEndDate: data.subscriptionEndDate !== "Invalid date" ? data.subscriptionEndDate : null,
      };
    },
    checkRoleAllows(checkRole) {
      return this.auth.roles.some((role) => role.slug.includes(checkRole));
    },
    appendSalespersonName() {
      // Get the salesperson name.
      const salespersonObj = this.salespersonData.find(
        (item) => item.email == this.applicationDetails.referByEmail
      );

      this.applicationDetails.referByName = salespersonObj.name;
    },
    selectTaxpodType(value) {
      this.applicationDetails.taxpodType = value;
      this.taxpodTypeDropdownOpen = false;
    },
    selectPaymentChannel(value) {
      this.applicationDetails.paymentChannel = value;
      this.paymentChannelDropdownOpen = false;
      this.changePaymentChannel();
    },
    selectPaymentMode(value) {
      this.applicationDetails.paymentMode = value;
      this.paymentModeDropdownOpen = false;
    },
    selectIsDuplicate(value) {
      this.applicationDetails.isApplicationDuplicate = value;
      this.isDuplicateDropdownOpen = false;
    },
    selectMoveStage(value) {
      this.applicationDetails.moveApplicationStage = value;
      this.moveStageDropdownOpen = false;
    },
    // --- PIC Name tag input ---
    addPicNameTag() {
      var val = (this.picNameInput || '').trim();
      if (val && this.companyDetails.picName.indexOf(val) === -1) {
        this.companyDetails.picName.push(val);
      }
      this.picNameInput = '';
    },
    removePicName(index) {
      this.companyDetails.picName.splice(index, 1);
    },
    selectPicNameSuggestion(item) {
      if (this.companyDetails.picName.indexOf(item) === -1) {
        this.companyDetails.picName.push(item);
      }
      this.picNameInput = '';
    },
    // --- PIC Email tag input ---
    addPicEmailTag() {
      var val = (this.picEmailInput || '').trim();
      if (val && this.companyDetails.picEmail.indexOf(val) === -1) {
        this.companyDetails.picEmail.push(val);
      }
      this.picEmailInput = '';
    },
    removePicEmail(index) {
      this.companyDetails.picEmail.splice(index, 1);
    },
    selectPicEmailSuggestion(item) {
      if (this.companyDetails.picEmail.indexOf(item) === -1) {
        this.companyDetails.picEmail.push(item);
      }
      this.picEmailInput = '';
    },
    // --- PIC Contact tag input ---
    addPicContactTag() {
      var val = (this.picContactInput || '').trim();
      if (val && this.companyDetails.picContactNo.indexOf(val) === -1) {
        this.companyDetails.picContactNo.push(val);
      }
      this.picContactInput = '';
    },
    removePicContact(index) {
      this.companyDetails.picContactNo.splice(index, 1);
    },
    selectPicContactSuggestion(item) {
      if (this.companyDetails.picContactNo.indexOf(item) === -1) {
        this.companyDetails.picContactNo.push(item);
      }
      this.picContactInput = '';
    },
    // --- Responder Email searchable dropdown ---
    selectResponderEmail(item) {
      this.applicationDetails.referByEmail = item;
      this.responderEmailDropdownOpen = false;
      this.responderEmailSearch = '';
      this.appendSalespersonName();
    },
    // --- Customer Service multi-select ---
    getCsText(val) {
      if (val && typeof val === 'object') return val.text || '';
      var found = (this.csDetails.customerServiceData || []).find(function(item) { return item.value === val; });
      return found ? found.text : String(val || '');
    },
    isCsSelected(value) {
      if (!this.csDetails.customerService) return false;
      return this.csDetails.customerService.some(function(item) {
        if (item && typeof item === 'object') return item.value === value;
        return item === value;
      });
    },
    toggleCustomerService(item) {
      if (!this.csDetails.customerService) {
        this.csDetails.customerService = [];
      }
      var idx = -1;
      for (var i = 0; i < this.csDetails.customerService.length; i++) {
        var curr = this.csDetails.customerService[i];
        var currVal = (curr && typeof curr === 'object') ? curr.value : curr;
        if (currVal === item.value) {
          idx = i;
          break;
        }
      }
      if (idx !== -1) {
        this.csDetails.customerService.splice(idx, 1);
      } else {
        this.csDetails.customerService.push(item.value);
      }
    },
    removeCustomerService(index) {
      this.csDetails.customerService.splice(index, 1);
    },
    redirectBack() {
      let route = "HrdcApplication";
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state.hrdc.data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
    },
    editApplication() {
      this.loadingBar = !this.loadingBar;

      let companyNameInVision = null;
      let companyName = this.companyDetails.oriCompanyName;
      let subscriptionStartDate =
        this.companyDetails.finalSubscriptionStartDate;
      let subscriptionEndDate = this.companyDetails.finalSubscriptionEndDate;

      if (this.isArrayofObjects(this.csDetails.customerService)) {
        this.csDetails.customerService = this.csDetails.customerService.map(
          (item) => item.value
        );
      }

      // Clear bank & screenshot if Claim Basis.
      if (this.applicationDetails.paymentChannel == 2) {
        this.companyDetails.bankUuid = null;
        this.companyDetails.bankAccNo = null;
        this.companyDetails.bankAccHolderName = null;
      }

      const fd = new FormData();
      fd.append("userUuid", this.auth.uuid);
      fd.append("applicationUuid", this.$route.query._ausk);
      fd.append("companyNameInVision", companyNameInVision);
      fd.append("companyUuid", this.companyDetails.companyUuid);
      fd.append("companySsmNo", this.companyDetails.companySsmNo);
      fd.append("companyTinNo", this.companyDetails.companyTinNo);
      fd.append("companyName", companyName);
      fd.append("subscriptionStartDate", subscriptionStartDate);
      fd.append("subscriptionEndDate", subscriptionEndDate);
      fd.append("companyAddress", this.companyDetails.companyAddress);
      fd.append("picName", this.companyDetails.picName.join(","));
      fd.append("picEmail", this.companyDetails.picEmail.join(","));
      fd.append("picContactNo", this.companyDetails.picContactNo.join(","));
      fd.append("bankUuid", this.applicationDetails.bankUuid);
      fd.append("bankAccNo", this.applicationDetails.bankAccNo);
      fd.append("bankAccHolderName", this.applicationDetails.bankAccHolderName);
      fd.append("customerService", this.csDetails.customerService);
      fd.append("taxpodPricing", this.companyDetails.taxpodPricing);
      fd.append("paymentChannel", this.applicationDetails.paymentChannel);
      fd.append("taxpodType", this.applicationDetails.taxpodType);
      fd.append("ssOfBankAcc", this.applicationDetails.ssOfBankAcc);
      fd.append(
        "firstNameAccEnrollment",
        this.enrollmentDetails.firstNameAccEnrollment
      );
      fd.append(
        "lastNameAccEnrollment",
        this.enrollmentDetails.lastNameAccEnrollment
      );
      fd.append(
        "contactNoAccEnrollment",
        this.enrollmentDetails.contactNoAccEnrollment
      );
      fd.append(
        "emailAccEnrollment",
        this.enrollmentDetails.emailAccEnrollment
      );
      fd.append(
        "dynamicEnrollmentDetails",
        JSON.stringify(this.dynamicEnrollmentDetails)
      );
      fd.append("programmeName", this.applicationDetails.programmeName);
      fd.append("paymentMode", this.applicationDetails.paymentMode);
      fd.append("referByName", this.applicationDetails.referByName);
      fd.append("referByEmail", this.applicationDetails.referByEmail);
      fd.append(
        "isApplicationDuplicate",
        this.applicationDetails.isApplicationDuplicate
      );
      fd.append(
        "finalSubscriptionStartDate",
        this.companyDetails.finalSubscriptionStartDate
      );
      fd.append(
        "finalSubscriptionEndDate",
        this.companyDetails.finalSubscriptionEndDate
      );
      fd.append(
        "moveApplicationStage",
        this.applicationDetails.moveApplicationStage
      );

      this.apiEditApplication.setParams(fd);
      this.apiEditApplication.setCallbackCompleted((response) => {
        try {
          this.loadingBar = !this.loadingBar;
          this.clearErrorMsg();
          if (!response.status) {
            this.showErrorMessage(response);
            this.$store.dispatch("showMessage", {
              message: "Please fill-in all the fields",
              messageType: "error",
              timeout: 2000,
            });
          }

          if (response.status) {
            let route = "HrdcApplication";
            if (this.params.backTo) {
              route = this.params.backTo;
            }

            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });

            this.$router.push({
              name: route,
              params: {
                modelKey: this.model.key,
                backTo: "",
              },
              query: {
                viewId: this.$store.state.hrdc.data.viewId,
                _ausk: this.$route.query._ausk,
              },
            });

            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
            return;
          }
          this.loadingBar = !this.loadingBar;
        } catch (err) {
          console.log(err);
        }
      });
      this.apiEditApplication.fetch();

      this.loadingBar = !this.loadingBar;
      this.alertEditApplicationDialog = !this.alertEditApplicationDialog;
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .edit-page {
  background-color: var(--app-page);
}

.dark-mode .edit-header {
  background: var(--app-elevated);
}

.dark-mode .back-btn {
  background: var(--app-card);
  border: 1px solid var(--app-border-strong);
}

.dark-mode .back-btn:hover {
  background: var(--app-surface);
  border-color: var(--app-border-strong);
}

.dark-mode .hero-action-btn {
  background: var(--app-elevated);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-elevated);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--blue {
  background: var(--app-accent-soft);
}

.dark-mode .hero-action-btn--blue:hover {
  background: var(--app-accent-soft);
}

.dark-mode .hero-action-btn--dark {
  background: var(--app-elevated);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--dark:hover {
  background: var(--app-elevated);
  color: var(--app-text);
}

.dark-mode .section-card {
  background: var(--app-elevated);
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .form-field__separator {
  color: var(--app-text-muted);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-card) !important;
  border: 1.5px solid var(--app-border-strong) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-border-strong) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot {
  background: var(--app-elevated) !important;
  border: 1px dashed var(--app-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection {
  color: var(--app-text-faint) !important;
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-text-muted);
}

.dark-mode .enrollment-action-btn--add {
  background: var(--app-accent);
}

.dark-mode .edit-confirm-card {
  background: var(--app-card);
}

.dark-mode .edit-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .edit-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .edit-confirm-card__btn--cancel {
  background: var(--app-card);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .edit-confirm-card__btn--cancel:hover {
  background: var(--app-surface);
}

.dark-mode .skel-header {
  background: var(--app-elevated);
}

.dark-mode .skel-line {
  background: linear-gradient(90deg, var(--app-elevated) 25%, var(--app-elevated) 50%, var(--app-elevated) 75%);
}

.dark-mode .skel-card {
  background: var(--app-elevated);
}

.dark-mode .edit-select__trigger {
  border: 1.5px solid var(--app-border-strong);
  background: var(--app-card);
}

.dark-mode .edit-select__trigger:hover {
  border-color: var(--app-border-strong);
}

.dark-mode .edit-select__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .edit-select__arrow {
  color: var(--app-text-faint);
}

.dark-mode .edit-select__dropdown {
  background: var(--app-surface);
  border: 1px solid var(--app-border);
}

.dark-mode .edit-select__dropdown::-webkit-scrollbar-thumb {
  background: var(--app-elevated);
}

.dark-mode .edit-select__option {
  color: var(--app-text);
}

.dark-mode .edit-select__option:hover {
  background: var(--app-surface);
}

.dark-mode .edit-select__option--selected {
  background: var(--app-accent-soft);
}

.dark-mode .edit-select__option--selected:hover {
  background: var(--app-accent-soft);
}

.dark-mode .edit-select__empty {
  color: var(--app-text-faint);
}

.dark-mode .edit-taginput__trigger {
  border: 1.5px solid var(--app-border-strong);
  background: var(--app-card);
}

.dark-mode .edit-taginput__trigger:hover {
  border-color: var(--app-border-strong);
}

.dark-mode .edit-taginput__chip-remove:hover {
  background: var(--app-accent-soft);
}

.dark-mode .edit-taginput__input::placeholder {
  color: var(--app-field-placeholder);
}

.dark-mode .edit-taginput__info-icon {
  color: var(--app-text-faint);
}

.dark-mode .edit-search__input::placeholder {
  color: var(--app-field-placeholder);
}

.dark-mode .edit-select__checkbox {
  border: 1.5px solid var(--app-border-strong);
  background: var(--app-card);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE WRAPPER
   ============================================ */
.edit-page {
  background-color: #d8dce2;
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  padding-top: 24px !important;
  padding-bottom: 60px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  zoom: 1.1;
}

/* ============================================
   EDIT HEADER
   ============================================ */
.edit-header {
  background: #eaecef;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
  overflow: hidden;
}

.edit-header__top {
  display: flex;
  align-items: center;
  padding: 24px 28px 16px;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d1d5db;
  cursor: pointer;
  margin-right: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.edit-header__info {
  flex: 1;
  min-width: 0;
}

.edit-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #3a3f47;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.2px;
}

.edit-header__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 16px;
}

/* Hero action buttons */
.hero-action-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.hero-action-btn:hover {
  background: #e2e8f0;
  color: #334155;
  transform: translateY(-1px);
}

.hero-icon {
  width: 18px;
  height: 18px;
}

.hero-action-btn--blue {
  background: #eff6ff;
  color: #3b82f6;
}

.hero-action-btn--blue:hover {
  background: #dbeafe;
  color: #2563eb;
}

.hero-action-btn--dark {
  background: #f1f5f9;
  color: #1e293b;
}

.hero-action-btn--dark:hover {
  background: #e2e8f0;
  color: #0f172a;
}

/* ============================================
   CARDS GRID LAYOUT
   ============================================ */
.cards-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 960px) {
  .cards-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.cards-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ============================================
   SECTION CARDS
   ============================================ */
.section-card {
  background: #eaecef;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.section-card:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.section-header {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header__title {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.section-body {
  padding: 22px;
  background: #fff;
}

.section-divider {
  border: none;
  border-top: 1px solid #eceef1;
  margin: 12px 0;
}

/* ============================================
   FORM ROWS & FIELDS
   ============================================ */
.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 12px;
}

.form-label {
  flex: 0 0 180px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3239;
  line-height: 1.6;
  padding-top: 10px;
}

.form-field {
  flex: 1;
  min-width: 0;
}

.form-field--inline {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.form-field__separator {
  font-size: 0.85rem;
  font-weight: 500;
  color: #64748b;
  padding-top: 10px;
  flex-shrink: 0;
}

/* Style Vuetify inputs to match design system */
.form-field >>> .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.form-field >>> .v-input__slot {
  border-radius: 10px !important;
  min-height: 40px !important;
}

.form-field >>> .v-text-field__details {
  margin-bottom: 0 !important;
  padding-top: 2px !important;
  min-height: 0 !important;
}

.form-field >>> .v-messages {
  min-height: 0 !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-radius: 10px !important;
}

.form-field >>> .v-input--is-focused .v-input__slot {
  border-color: #56bde8 !important;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12) !important;
}

.form-field >>> .v-input__slot::before,
.form-field >>> .v-input__slot::after {
  display: none !important;
}

/* Editable fields - white background with visible border */
.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: #fff !important;
  border: 1.5px solid #d1d5db !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: #94a3b8 !important;
}

/* Disabled / read-only fields - flat muted look */
.form-field >>> .v-input--is-disabled .v-input__slot {
  background: #f1f5f9 !important;
  border: 1px dashed #e2e8f0 !important;
  cursor: not-allowed !important;
}

.form-field >>> .v-input--is-disabled input,
.form-field >>> .v-input--is-disabled textarea,
.form-field >>> .v-input--is-disabled .v-select__selection {
  color: #94a3b8 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-focused) > .v-input__control > .v-input__slot::before {
  border: none !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot::after {
  border: none !important;
}

.form-field >>> .v-label {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  color: #64748b;
}

.form-field >>> .v-text-field input,
.form-field >>> .v-select__selection,
.form-field >>> .v-text-field textarea {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
}

/* Error state */
.form-field >>> .v-input--has-state .v-input__slot {
  border-color: #f87171 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled).v-input--has-state > .v-input__control > .v-input__slot {
  border-color: #ef4444 !important;
}

.form-field >>> .v-messages__message {
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  color: #ef4444;
}

/* ============================================
   ENROLLMENT SECTION
   ============================================ */
.enrollment-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 12px;
}

.enrollment-col {
  /* column in enrollment grid */
}

.enrollment-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}

.enrollment-action-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.enrollment-action-btn--add {
  background: #063058;
  color: #fff;
}

.enrollment-action-btn--add:hover {
  background: #0a4a80;
  transform: translateY(-1px);
}

.enrollment-action-btn--remove {
  background: #ef4444;
  color: #fff;
}

.enrollment-action-btn--remove:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

/* ============================================
   EDIT CONFIRM DIALOG
   ============================================ */
.edit-confirm-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

.edit-confirm-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 32px 24px;
  text-align: center;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.edit-confirm-card__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 10px;
}

.edit-confirm-card__message {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0 0 24px;
  line-height: 1.5;
}

.edit-confirm-card__actions {
  display: flex;
  gap: 12px;
}

.edit-confirm-card__btn {
  flex: 1;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.edit-confirm-card__btn--cancel {
  background: #fff;
  color: #0ea5e9;
  border: 1.5px solid #d1d5db;
}

.edit-confirm-card__btn--cancel:hover {
  background: #f8fafc;
  border-color: #0ea5e9;
}

.edit-confirm-card__btn--confirm {
  background: #56bde8;
  color: #fff;
  border: none;
}

.edit-confirm-card__btn--confirm:hover {
  background: #3dadd8;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.3);
}

/* ============================================
   PAGE LOADER / SKELETON
   ============================================ */
.page-loader {
  padding: 0;
}

.skel-header {
  background: #eaecef;
  border-radius: 14px;
  padding: 28px;
  margin-bottom: 24px;
}

.skel-line {
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #dfe1e5 25%, #e8eaed 50%, #dfe1e5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 10px;
}

.skel-line--sm { width: 30%; }
.skel-line--md { width: 50%; }
.skel-line--lg { width: 70%; height: 14px; }
.skel-line--full { width: 100%; }

.skel-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.skel-card {
  background: #eaecef;
  border-radius: 14px;
  overflow: hidden;
}

.skel-card__header {
  height: 42px;
  background: linear-gradient(90deg, #cdd1d6 25%, #d8dce0 50%, #cdd1d6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skel-card__body {
  padding: 20px;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ============================================
   MOBILE RESPONSIVE
   ============================================ */
@media (max-width: 599px) {
  .edit-page {
    padding: 12px 8px !important;
    zoom: 1;
  }

  .edit-header {
    border-radius: 14px;
    margin-bottom: 16px;
  }

  .edit-header__top {
    flex-wrap: wrap;
    padding: 16px 16px 12px;
  }

  .back-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    margin-right: 12px;
  }

  .edit-header__title {
    font-size: 1.05rem;
    white-space: normal;
  }

  .edit-header__actions {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 4px;
  }

  /* Hero action buttons - usable size on mobile */
  .hero-action-btn {
    width: 36px;
    height: 36px;
  }

  /* Grid stacks to single column */
  .cards-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .cards-column {
    gap: 16px;
  }

  .section-card {
    border-radius: 14px;
  }

  .section-header {
    padding: 12px 16px;
  }

  .section-header__title {
    font-size: 0.65rem;
    letter-spacing: 1.5px;
  }

  .section-body {
    padding: 14px;
  }

  .enrollment-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .form-row {
    flex-direction: column;
    gap: 2px;
    align-items: stretch;
  }

  .form-label {
    flex: none;
    width: 100%;
    font-size: 0.72rem;
    padding-top: 0;
    margin-bottom: 2px;
  }

  .form-field {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  /* Vuetify inputs full width */
  .form-field >>> .v-input {
    width: 100% !important;
  }

  .form-field >>> .v-input__control {
    width: 100% !important;
  }

  .form-field >>> .v-input__slot {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Date picker inline fields stack on mobile */
  .form-field--inline {
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .form-field__separator {
    display: none;
  }

  /* Custom dropdowns full width on mobile */
  .edit-select,
  .edit-taginput {
    width: 100%;
  }

  .edit-select__trigger,
  .edit-taginput__trigger {
    min-height: 38px;
    width: 100%;
    box-sizing: border-box;
  }

  .edit-select__dropdown {
    max-height: 200px;
    width: 100%;
    box-sizing: border-box;
  }

  .edit-taginput__chip {
    font-size: 0.72rem;
    padding: 2px 4px 2px 8px;
  }

  /* Section body overflow */
  .section-body {
    overflow: hidden;
    word-break: break-word;
  }

  .section-card {
    max-width: 100%;
    overflow: hidden;
  }

  .cards-column {
    min-width: 0;
    max-width: 100%;
  }

  /* Prevent page horizontal scroll */
  .edit-page {
    overflow-x: hidden;
  }

  /* Dialog smaller padding on mobile */
  .edit-confirm-card {
    padding: 24px 20px 20px;
  }

  .edit-confirm-card__title {
    font-size: 1.05rem;
  }

  .skel-grid {
    grid-template-columns: 1fr;
  }
}

/* Tablet breakpoint */
@media (min-width: 600px) and (max-width: 959px) {
  .edit-page {
    zoom: 1;
  }

  .edit-header__top {
    padding: 20px 20px 14px;
  }

  .edit-header__title {
    font-size: 1.15rem;
  }

  .edit-header__actions {
    flex-wrap: wrap;
    gap: 4px;
  }

  .cards-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .section-body {
    padding: 18px;
  }

  .form-label {
    flex: 0 0 160px;
  }

  /* Enrollment row stays 2-col on tablet */
  .enrollment-row {
    grid-template-columns: 1fr 1fr;
  }

  /* Custom dropdowns full width */
  .edit-select,
  .edit-taginput {
    width: 100%;
  }
}

/* ============================================
   DARK MODE

   The tier ramp this page is built on, because the previous version painted
   page, header, section card, section body AND every input the same
   --app-page: the whole form read as one flat black plane with no card edges
   and fields you could only find by clicking. Top to bottom:

     page        --app-page          the ground everything sits on
     card        --app-card          header, section cards, dialog
     field       --app-field         anything you can type into or open
     popup       --app-elevated      dropdown panels floating over a field
     tile        --app-form-tile     icon buttons sitting on a card

   --app-field / --app-form-tile exist precisely for this: on a light page a
   field is defined by being white against a tinted card (a step UP), and that
   same rule written as a raw tier lands on --app-page in dark, which is a step
   DOWN and buries the field. See the token header in theme-dark.css.
   ============================================ */
.dark-mode .edit-page {
  background-color: var(--app-page);
}

.dark-mode .edit-header {
  background: var(--app-card);
  border: 1px solid var(--app-border);
  box-shadow: inset 0 1px 0 var(--app-inner-highlight);
}

.dark-mode .edit-header__title {
  color: var(--app-text);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .section-card {
  background: var(--app-card);
  border: 1px solid var(--app-border);
  box-shadow: inset 0 1px 0 var(--app-inner-highlight);
}

.dark-mode .section-card:hover {
  box-shadow:
    inset 0 1px 0 var(--app-inner-highlight),
    0 3px 12px var(--app-shadow-mid);
}

/* --- Section headers — the neutral dark band, same treatment as
       hrdc/views/application/View.vue.

       The light theme paints these with a saturated sky gradient
       (#0ea5e9 -> #38bdf8); dark used to carry that over as a flat, undiluted
       --app-accent bar, and a column of those on charcoal is the glare this
       page was reported for. The band is now neutral — var(--app-elevated),
       one step above the --app-card body it caps, closed by --app-border and lifted by the same
       `inset 0 1px 0` highlight every other raised surface uses — so it reads
       as a header by GEOMETRY rather than by hue. The accent survives only at
       sizes small enough to be a cue instead of a field: a 2px spine that fades
       out down the band, and the icon glyph. */
.dark-mode .section-header {
  position: relative;
  background-color: var(--app-elevated);
  background-image: none;
  border-bottom: 1px solid var(--app-border);
  box-shadow: inset 0 1px 0 var(--app-inner-highlight);
}

/* What is left of the accent: 2px wide and faded top-to-bottom, so it marks
   the header's start without drawing a hard full-height rail.
   .section-card's overflow clips it to the card radius. */
.dark-mode .section-header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(
    180deg,
    rgba(var(--app-accent-rgb), 0.55),
    rgba(var(--app-accent-rgb), 0.12)
  );
}

.dark-mode .section-header__title {
  color: var(--app-text);
  font-weight: 700;
  letter-spacing: 1.6px;
}

/* The icon can hold the accent now that the band behind it is neutral.
   `color="white"` on the tag compiles to .white--text (0,1,0 + !important);
   this is (0,3,0 + !important) and wins. */
.dark-mode .section-header .v-icon {
  color: var(--app-accent) !important;
  opacity: 0.85;
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .section-divider {
  border-top-color: var(--app-border);
}

.dark-mode .form-label {
  color: var(--app-text-muted);
}

.dark-mode .form-field__separator {
  color: var(--app-text-faint);
}

/* Editable fields — one step ABOVE the card, with a border bright enough to
   read as a target you can click into. */
.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  background: var(--app-field-hover) !important;
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-focused .v-input__slot {
  border-color: var(--app-accent) !important;
  box-shadow: 0 0 0 3px var(--app-ring) !important;
}

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text);
}

.dark-mode .form-field >>> .v-label,
.dark-mode .form-field >>> input::placeholder,
.dark-mode .form-field >>> textarea::placeholder {
  color: var(--app-field-placeholder);
}

.dark-mode .form-field >>> .v-icon {
  color: var(--app-text-faint);
}

/* Disabled goes the other way — recessed below the card and dashed, so
   "not editable" reads without relying on the text colour alone. */
.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection {
  color: var(--app-text-faint) !important;
}

.dark-mode .form-field >>> .v-input--has-state .v-input__slot,
.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled).v-input--has-state > .v-input__control > .v-input__slot {
  border-color: var(--app-danger) !important;
}

.dark-mode .form-field >>> .v-messages__message {
  color: var(--app-danger);
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

/* Was --app-neutral-fg (#555) on hover: a dark-grey ink on a dark tile, i.e.
   the icon disappeared exactly when you pointed at it. */
.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--blue {
  background: var(--app-accent-soft);
  color: var(--app-accent);
}

.dark-mode .hero-action-btn--blue:hover {
  background: var(--app-accent-soft);
  color: var(--app-accent-strong);
}

.dark-mode .enrollment-action-btn--add {
  background: var(--app-accent);
  color: var(--app-accent-fg);
}

.dark-mode .enrollment-action-btn--add:hover {
  background: var(--app-accent-strong);
}

.dark-mode .enrollment-action-btn--remove {
  background: var(--app-danger);
  color: var(--app-on-solid);
}

.dark-mode .enrollment-action-btn--remove:hover {
  background: var(--app-danger);
  filter: brightness(1.1);
}

/* The dialog floats over a near-black scrim, so it has to be a card tier —
   on --app-page it had no edge against the dimmed page behind it. */
.dark-mode .edit-confirm-card {
  background: var(--app-card);
  border: 1px solid var(--app-border);
}

.dark-mode .edit-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .edit-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .edit-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  color: var(--app-accent-strong);
  border-color: var(--app-border-strong);
}

.dark-mode .edit-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-accent-strong);
}

/* White on #38bdf8 is barely legible — the accent fill takes --app-accent-fg. */
.dark-mode .edit-confirm-card__btn--confirm {
  background: var(--app-accent);
  color: var(--app-accent-fg);
}

.dark-mode .edit-confirm-card__btn--confirm:hover {
  background: var(--app-accent-strong);
  box-shadow: 0 4px 12px var(--app-accent-glow);
}

.dark-mode .skel-header,
.dark-mode .skel-card {
  background: var(--app-card);
  border: 1px solid var(--app-border);
}

.dark-mode .skel-line {
  background: linear-gradient(90deg, var(--app-surface) 25%, var(--app-elevated) 50%, var(--app-surface) 75%);
  background-size: 200% 100%;
}

.dark-mode .skel-card__header {
  background: linear-gradient(90deg, var(--app-elevated) 25%, var(--app-border-strong) 50%, var(--app-elevated) 75%);
  background-size: 200% 100%;
}

/* ============================================
   CUSTOM DROPDOWN (edit-select)
   ============================================ */
.edit-select {
  position: relative;
}

.edit-select__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 6px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
}

.edit-select__trigger:hover {
  border-color: #94a3b8;
}

.edit-select__trigger--open {
  border-color: #56bde8;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12);
}

.edit-select__trigger--error {
  border-color: #ef4444;
}

.edit-select__value {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
}

.edit-select__placeholder {
  color: #94a3b8;
  font-size: 0.85rem;
  font-weight: 400;
}

.edit-select__arrow {
  width: 20px;
  height: 20px;
  color: #94a3b8;
  transition: transform 0.2s ease;
  flex-shrink: 0;
  margin-left: 4px;
}

.edit-select__arrow--open {
  transform: rotate(180deg);
}

.edit-select__dropdown {
  margin-top: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  max-height: 180px;
  overflow-y: auto;
  padding: 4px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.edit-select__dropdown::-webkit-scrollbar {
  width: 5px;
}

.edit-select__dropdown::-webkit-scrollbar-track {
  background: transparent;
}

.edit-select__dropdown::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.edit-select__dropdown::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.edit-select__option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 7px;
  font-size: 0.85rem;
  font-family: 'Lato', sans-serif;
  color: #334155;
  cursor: pointer;
  transition: background 0.12s;
}

.edit-select__option:hover {
  background: #f8fafc;
}

.edit-select__option--selected {
  background: #f0f9ff;
}

.edit-select__option--selected:hover {
  background: #e0f2fe;
}

.edit-select__empty {
  padding: 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 0.85rem;
}

.edit-select__error {
  margin-top: 6px;
  font-size: 0.8rem;
  color: #ef4444;
  font-family: 'Lato', sans-serif;
}

.edit-select__error-item {
  padding-left: 12px;
  position: relative;
  line-height: 1.5;
}

.edit-select__error-item::before {
  content: '\2022';
  position: absolute;
  left: 0;
}

/* Dark mode - save button. Sits one step above the other header tiles so the
   only write action on the page still leads, and picks up the accent on hover
   instead of climbing further up the grey ramp. */
.dark-mode .hero-action-btn--dark {
  background: var(--app-elevated);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--dark:hover {
  background: var(--app-accent-soft);
  color: var(--app-accent-strong);
}

/* Dark mode - custom dropdown. Trigger is a field (one step above the card),
   the panel it opens is --app-elevated so it floats above that field rather
   than merging with it. */
.dark-mode .edit-select__trigger {
  background: var(--app-field);
  border-color: var(--app-field-border);
  color: var(--app-text);
}

.dark-mode .edit-select__trigger:hover {
  background: var(--app-field-hover);
  border-color: var(--app-field-border-hover);
}

.dark-mode .edit-select__trigger--open {
  border-color: var(--app-accent);
  box-shadow: 0 0 0 3px var(--app-ring);
}

.dark-mode .edit-select__value {
  color: var(--app-text);
}

.dark-mode .edit-select__placeholder {
  color: var(--app-field-placeholder);
}

.dark-mode .edit-select__dropdown {
  background: var(--app-elevated);
  border-color: var(--app-border-strong);
  box-shadow: 0 10px 28px var(--app-shadow);
}

.dark-mode .edit-select__dropdown::-webkit-scrollbar-thumb {
  background: var(--app-border-strong);
}

.dark-mode .edit-select__dropdown::-webkit-scrollbar-thumb:hover {
  background: var(--app-text-faint);
}

.dark-mode .edit-select__option {
  color: var(--app-text);
}

/* Was --app-elevated, the panel's own background: hovering a row did nothing
   visible. --app-hover is the neutral wash meant to sit on top of a tier. */
.dark-mode .edit-select__option:hover {
  background: var(--app-hover);
}

.dark-mode .edit-select__option--selected,
.dark-mode .edit-select__option--selected:hover {
  background: var(--app-accent-soft);
  color: var(--app-accent-strong);
}

.dark-mode .edit-select__empty {
  color: var(--app-text-faint);
}

.dark-mode .edit-select__error,
.dark-mode .v-messages__message {
  color: var(--app-danger);
}

/* ============================================
   TAG INPUT (edit-taginput) - combobox replacement
   ============================================ */
.edit-taginput {
  position: relative;
}

.edit-taginput__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 6px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  cursor: text;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
}

.edit-taginput__trigger:hover {
  border-color: #94a3b8;
}

.edit-taginput__trigger--open {
  border-color: #56bde8;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12);
}

.edit-taginput__trigger--error {
  border-color: #ef4444;
}

.edit-taginput__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
  align-items: center;
}

.edit-taginput__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #f0f7ff;
  color: #0369a1;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  padding: 3px 6px 3px 10px;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1.4;
}

.edit-taginput__chip-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  transition: background 0.15s;
}

.edit-taginput__chip-remove:hover {
  background: #e0f2fe;
}

.edit-taginput__input {
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
  flex: 1;
  min-width: 120px;
  padding: 2px 0;
}

.edit-taginput__input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.edit-taginput__info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  margin-left: 2px;
}

.edit-taginput__info-icon {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  transition: color 0.15s;
}

.edit-taginput__info:hover .edit-taginput__info-icon {
  color: #0ea5e9;
}

/* Search input for searchable dropdown */
.edit-search__input {
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
  flex: 1;
  min-width: 0;
  padding: 2px 0;
  width: 100%;
}

.edit-search__input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

/* Checkbox for multi-select dropdown */
.edit-select__checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1.5px solid #d1d5db;
  background: #fff;
  flex-shrink: 0;
  transition: all 0.15s ease;
}

.edit-select__checkbox--checked {
  background: #56bde8;
  border-color: #56bde8;
}

/* Dark mode - tag input. Same field tier as edit-select, so the two controls
   that sit side by side in a form row no longer render as different surfaces. */
.dark-mode .edit-taginput__trigger {
  background: var(--app-field);
  border-color: var(--app-field-border);
}

.dark-mode .edit-taginput__trigger:hover {
  background: var(--app-field-hover);
  border-color: var(--app-field-border-hover);
}

.dark-mode .edit-taginput__trigger--open {
  border-color: var(--app-accent);
  box-shadow: 0 0 0 3px var(--app-ring);
}

.dark-mode .edit-taginput__chip {
  background: var(--app-accent-soft);
  color: var(--app-accent-strong);
  border-color: var(--app-accent-border);
}

.dark-mode .edit-taginput__chip-remove:hover {
  background: var(--app-accent-soft);
}

.dark-mode .edit-taginput__input {
  color: var(--app-text);
}

.dark-mode .edit-taginput__input::placeholder {
  color: var(--app-field-placeholder);
}

.dark-mode .edit-taginput__info-icon {
  color: var(--app-text-faint);
}

.dark-mode .edit-taginput__info:hover .edit-taginput__info-icon {
  color: var(--app-accent-strong);
}

.dark-mode .edit-search__input {
  color: var(--app-text);
}

.dark-mode .edit-search__input::placeholder {
  color: var(--app-field-placeholder);
}

.dark-mode .edit-select__checkbox {
  background: var(--app-field);
  border-color: var(--app-field-border);
}

.dark-mode .edit-select__checkbox--checked {
  background: var(--app-accent);
  border-color: var(--app-accent);
}

/* The tick is `color="#fff"` in the template, i.e. an inline style — white on
   the dark theme's brighter accent is the one place a checked box stopped
   reading as checked. --app-accent-fg is the ink that pairs with an accent
   fill, and only !important can reach past the inline colour. */
.dark-mode .edit-select__checkbox--checked .v-icon {
  color: var(--app-accent-fg) !important;
}

/* ============================================
   VUETIFY OVERRIDES
   ============================================ */
.v-btn {
  opacity: 1 !important;
}

.v-messages__message {
  color: #ef4444;
}


/* >>> dark companions: the light rules above pin these to a dark ink
   with !important, which on the dark field renders the text invisible
   rather than absent. Token references only. <<< */

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text) !important;
}
</style>
